import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './WorkbenchPreviewSiteBanner.css';

function isWorkbenchPreviewHost() {
    if (typeof window === 'undefined') return false;
    const host = String(window.location.hostname || '').toLowerCase();
    const port = window.location.port || '';
    const productHost = host === 'www.internationalpropertymarket.com'
        || host === 'internationalpropertymarket.com'
        || host === 'localhost'
        || host === '127.0.0.1';
    // The preview script tag is in every page. Do not treat that as a preview host.
    if (productHost) return port === '3011';
    if (port === '3011') return true;
    if (host.includes('run.app')) return true;
    if (host.includes('ipm-workbench-preview')) return true;
    return false;
}

export default function WorkbenchPreviewSiteBanner() {
    const [line, setLine] = useState('');
    const barRef = useRef(null);

    useLayoutEffect(() => {
        const root = document.documentElement;
        if (!line) {
            root.style.removeProperty('--ipm-preview-banner-h');
            return undefined;
        }
        const el = barRef.current;
        if (!el) return undefined;
        const sync = () => {
            root.style.setProperty('--ipm-preview-banner-h', `${el.offsetHeight}px`);
        };
        sync();
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(sync) : null;
        if (ro) ro.observe(el);
        return () => {
            if (ro) ro.disconnect();
            root.style.removeProperty('--ipm-preview-banner-h');
        };
    }, [line]);

    useEffect(() => {
        if (!isWorkbenchPreviewHost()) return undefined;
        let cancelled = false;
        const pull = () => {
            fetch(`/preview-head.json?t=${Date.now()}`, { cache: 'no-store' })
                .then((r) => (r.ok ? r.json() : null))
                .then((data) => {
                    if (cancelled || !data) return;
                    const branch = String(data.branch || '').trim();
                    const sha = String(data.sha || '').trim();
                    if (!branch && !sha) return;
                    const text = `Live preview VM · ${branch || 'unknown'}${sha ? ` · ${sha}` : ''}`;
                    setLine(text);
                })
                .catch(() => {});
        };
        pull();
        const id = window.setInterval(pull, 4000);
        return () => {
            cancelled = true;
            window.clearInterval(id);
        };
    }, []);

    if (!line) return null;

    return (
        <div ref={barRef} className="ipm-preview-site-banner" role="status">
            {line}
        </div>
    );
}
